import React from 'react';
import PropTypes from 'prop-types';

const { number, string } = PropTypes;

const FilteredLabel = ({ label, count }) => <span>
  <span>{label}</span>
  <span style={{
    borderColor: 'rgb(189, 189, 189)',
    borderLeftStyle: 'solid',
    borderLeftWidth: '1px',
    minHeight: '28px',
    margin: '0 10px',
  }}
  ></span>
<span>{count}</span>
</span>;

FilteredLabel.propTypes = {
  label: string.isRequired,
  count: number,
};

export default FilteredLabel;



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/dashboardFilter/filteredLabel.jsx